/* ============================================================
   MASAMORTIS — FX
   Reveal a righe (maschera), reveal a blocchi, parallax,
   header reattivo, drawer. Zero dipendenze.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     1. SPLIT IN RIGHE
     Ricostruisce il contenuto in parole, misura la riga reale
     e raggruppa in .mm-line > span per la maschera.
     --------------------------------------------------------- */
  var INLINE_OK = { B: 1, STRONG: 1, EM: 1, I: 1, SPAN: 1, A: 1, SMALL: 1 };

  function toWords(node, out) {
    Array.prototype.forEach.call(node.childNodes, function (child) {
      if (child.nodeType === 3) {
        var parts = child.textContent.split(/(\s+)/);
        parts.forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            out.push(document.createTextNode(' '));
            return;
          }
          var w = document.createElement('span');
          w.className = 'mm-w';
          w.style.display = 'inline-block';
          w.textContent = part;
          out.push(w);
        });
      } else if (child.nodeType === 1) {
        if (child.tagName === 'BR') {
          out.push(child.cloneNode());
          return;
        }
        if (INLINE_OK[child.tagName]) {
          var inner = [];
          toWords(child, inner);
          inner.forEach(function (n) {
            if (n.nodeType === 1 && n.classList && n.classList.contains('mm-w')) {
              var clone = child.cloneNode(false);
              clone.appendChild(document.createTextNode(n.textContent));
              var wrap = document.createElement('span');
              wrap.className = 'mm-w';
              wrap.style.display = 'inline-block';
              wrap.appendChild(clone);
              out.push(wrap);
            } else {
              out.push(n);
            }
          });
        } else {
          out.push(child.cloneNode(true));
        }
      }
    });
  }

  function splitLines(el) {
    if (!el.dataset.mmOriginal) el.dataset.mmOriginal = el.innerHTML;
    el.innerHTML = el.dataset.mmOriginal;

    var words = [];
    toWords(el, words);
    el.innerHTML = '';
    words.forEach(function (n) { el.appendChild(n); });

    var nodes = el.querySelectorAll('.mm-w');
    if (!nodes.length) return;

    var lines = [];
    var current = null;
    var lastTop = null;

    Array.prototype.forEach.call(nodes, function (w) {
      var top = w.offsetTop;
      if (lastTop === null || Math.abs(top - lastTop) > 3) {
        current = [];
        lines.push(current);
        lastTop = top;
      }
      current.push(w);
    });

    var frag = document.createDocumentFragment();
    lines.forEach(function (words, i) {
      var line = document.createElement('span');
      line.className = 'mm-line';
      var inner = document.createElement('span');
      inner.style.setProperty('--d', (i * 0.085).toFixed(3) + 's');
      words.forEach(function (w, j) {
        inner.appendChild(w);
        if (j < words.length - 1) inner.appendChild(document.createTextNode(' '));
      });
      line.appendChild(inner);
      frag.appendChild(line);
    });

    el.innerHTML = '';
    el.appendChild(frag);
    el.classList.add('mm-lines');
  }

  var splitTargets = [];

  function initSplit() {
    splitTargets = Array.prototype.slice.call(document.querySelectorAll('[data-mm-split]'));
    if (reduced) {
      splitTargets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    splitTargets.forEach(splitLines);
  }

  /* ---------------------------------------------------------
     2. REVEAL
     --------------------------------------------------------- */
  var revealObserver = null;

  function initReveal() {
    var targets = document.querySelectorAll('[data-mm-reveal], [data-mm-split]');
    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = revealObserver || new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    revealObserver = io;
    Array.prototype.forEach.call(targets, function (el) {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  /* Shopify inietta pezzi di pagina via AJAX (prodotti correlati, filtri,
     risultati di ricerca): quei nodi non sono nel primo giro di osservazione
     e resterebbero invisibili. Qui li agganciamo appena compaiono. */
  function watchNewContent() {
    if (reduced || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (records) {
      var found = false;
      records.forEach(function (r) {
        Array.prototype.forEach.call(r.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && (n.matches('[data-mm-reveal]') || n.querySelector('[data-mm-reveal]'))) found = true;
        });
      });
      if (found) initReveal();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------
     3. PARALLAX
     --------------------------------------------------------- */
  var parallaxItems = [];
  var ticking = false;

  function readParallax() {
    parallaxItems = Array.prototype.map.call(
      document.querySelectorAll('[data-mm-parallax]'),
      function (el) {
        return { el: el, speed: parseFloat(el.dataset.mmParallax) || 0.12 };
      }
    );
  }

  function onScroll() {
    if (ticking || reduced) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxItems.forEach(function (item) {
        var rect = item.el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        item.el.style.transform = 'translate3d(0,' + (progress * item.speed * 100).toFixed(2) + 'px,0)';
      });
      ticking = false;
    });
  }

  /* ---------------------------------------------------------
     4. HEADER
     --------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('[data-mm-header]');
    if (!header) return;
    var last = 0;

    function update() {
      var y = window.pageYOffset;
      header.classList.toggle('is-stuck', y > 40);
      if (y > 320 && y > last + 6) header.classList.add('is-hidden');
      else if (y < last - 6 || y < 320) header.classList.remove('is-hidden');
      last = y;
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------------------------------------------------------
     4bis. MEGA-MENU
     Il solo :hover del CSS non basta (touch, e il puntatore che
     attraversa lo spazio fra voce e pannello): qui pilotiamo una
     classe, con un ritardo in uscita.
     --------------------------------------------------------- */
  function initMenu() {
    var items = document.querySelectorAll('.mm-nav-item');
    if (!items.length) return;

    var canHover = window.matchMedia('(hover: hover)').matches;

    Array.prototype.forEach.call(items, function (item) {
      var timer = null;
      var trigger = item.querySelector('.mm-header__link--parent');

      function open() {
        clearTimeout(timer);
        Array.prototype.forEach.call(items, function (other) {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      function close(delay) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, delay || 0);
      }

      if (canHover) {
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', function () { close(180); });
      }

      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(0);
      });

      /* touch: il primo tocco apre, il secondo segue il link */
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (canHover) return;
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            open();
          }
        });
      }

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close(0);
          if (trigger) trigger.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.mm-nav-item')) return;
      Array.prototype.forEach.call(items, function (item) { item.classList.remove('is-open'); });
    });
  }

  /* ---------------------------------------------------------
     5. DRAWER
     --------------------------------------------------------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-mm-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-mm-drawer-open]');
    var closers = drawer.querySelectorAll('[data-mm-drawer-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
      Array.prototype.forEach.call(openers, function (o) { o.setAttribute('aria-expanded', 'true'); });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      Array.prototype.forEach.call(openers, function (o) { o.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }

    Array.prototype.forEach.call(openers, function (o) { o.addEventListener('click', open); });
    Array.prototype.forEach.call(closers, function (c) { c.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }


  /* ---------------------------------------------------------
     6. LA PORTA — passaggio da una pagina all'altra
     La transizione nativa del browser non parte dentro un iframe
     (anteprima e personalizzatore di Shopify lo sono): la disegnamo noi.
     --------------------------------------------------------- */
  function initGate() {
    if (reduced) return;

    var gate = document.createElement('div');
    gate.className = 'mm-gate';
    gate.setAttribute('aria-hidden', 'true');
    gate.innerHTML =
      '<span class="mm-gate__line"></span>' +
      '<span class="mm-gate__seal">' +
      (document.querySelector('.mm-header__brand .mm-seal')
        ? document.querySelector('.mm-header__brand .mm-seal').innerHTML
        : '') +
      '</span>';
    document.body.appendChild(gate);

    var root = document.documentElement;

    /* arrivo: il velo e' gia' chiuso dallo script nel <head> (niente lampo).
       Qui lo apriamo appena la pagina e' pronta a mostrarsi. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.remove('mm-closed');
        root.classList.add('mm-entering');
        setTimeout(function () { root.classList.remove('mm-entering'); }, 900);
      });
    });

    /* partenza: il buio si chiude, poi si naviga.
       In fase di cattura, cosi' arriviamo prima degli script di Shopify
       (nell'anteprima riscrivono i link e ci toglierebbero l'evento). */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;
      if (link.hasAttribute('data-no-transition')) return;
      /* filtri e ricerca predittiva gestiscono la navigazione da soli */
      if (link.closest('.facets, predictive-search, .pagination__item--prev, .mm-trail')) return;

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

      var url;
      try { url = new URL(link.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      /* il carrello e il checkout devono restare immediati */
      if (/\/(cart|checkout|account)/.test(url.pathname)) return;

      e.preventDefault();
      root.classList.add('mm-leaving');
      setTimeout(function () { window.location.href = link.href; }, 420);
      /* se per qualsiasi motivo la pagina non cambia, il buio non resta chiuso */
      setTimeout(function () { root.classList.remove('mm-leaving'); }, 2500);
    }, true);

    /* qualunque altra uscita (form, script di terzi): il velo si chiude comunque */
    window.addEventListener('pagehide', function () {
      root.classList.add('mm-leaving');
    });

    /* tornando indietro dalla cache il velo non deve restare chiuso */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) root.classList.remove('mm-leaving');
    });
  }

  /* ---------------------------------------------------------
     7. IL CAMMINO — sentiero laterale con lanterna
     --------------------------------------------------------- */
  var trailReady = false;

  function initTrail() {
    if (reduced || trailReady) return;
    /* se la finestra e' stretta il sentiero non serve: riproveremo al ridimensionamento */
    if (!window.matchMedia('(min-width: 1100px)').matches) return;

    var main = document.getElementById('MainContent') || document.body;
    /* SOLO le sezioni che si sono dichiarate una tappa: i contenitori che
       Shopify genera attorno alle sezioni hanno id tecnici (shopify-section-...)
       e non devono finire nel cammino. */
    var sections = Array.prototype.filter.call(
      main.querySelectorAll('[data-mm-title][id]'),
      function (el) { return el.offsetHeight > 200; }
    );
    if (sections.length < 3) return;

    function labelFor(el) {
      var t = (el.dataset.mmTitle || '').trim();
      if (!t) return '';
      return t.length > 24 ? t.slice(0, 23) + '…' : t;
    }

    var nav = document.createElement('nav');
    nav.className = 'mm-trail';
    nav.setAttribute('aria-label', 'Il cammino');
    var html = '<span class="mm-trail__line"></span><span class="mm-trail__lantern"></span><ul class="mm-trail__list">';
    sections.forEach(function (sec, i) {
      html +=
        '<li class="mm-trail__item" data-i="' + i + '">' +
        '<a class="mm-trail__dot" href="#' + sec.id + '">' +
        '<span class="visually-hidden">' + labelFor(sec) + '</span></a>' +
        '<span class="mm-trail__label">' + labelFor(sec) + '</span>' +
        '</li>';
    });
    html += '</ul>';
    nav.innerHTML = html;
    document.body.appendChild(nav);
    trailReady = true;

    var items = nav.querySelectorAll('.mm-trail__item');
    var raf = false;

    /* Ogni tacca sta dove sta davvero la sua sezione nel documento:
       cosi' la lanterna (che segue il progresso di scorrimento) passa
       esattamente sopra il punto della tappa. */
    function place() {
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var anchor = window.innerHeight * 0.4;
      Array.prototype.forEach.call(items, function (it, i) {
        var top = sections[i].getBoundingClientRect().top + window.pageYOffset;
        var at = (top - anchor) / scrollable;
        it.style.top = Math.max(0, Math.min(1, at)) * 100 + '%';
      });
    }

    function update() {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        var p = scrollable > 0 ? (window.pageYOffset / scrollable) * 100 : 0;
        p = Math.max(0, Math.min(100, p));
        nav.style.setProperty('--mm-trail-progress', p + '%');

        var anchor = window.innerHeight * 0.4;
        var current = 0;
        sections.forEach(function (sec, i) {
          if (sec.getBoundingClientRect().top <= anchor) current = i;
        });
        Array.prototype.forEach.call(items, function (it, i) {
          it.classList.toggle('is-current', i === current);
          it.classList.toggle('is-done', i < current);
        });
        raf = false;
      });
    }

    place();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { place(); update(); });
    /* le immagini che finiscono di caricare cambiano le altezze: rimisuriamo */
    window.addEventListener('load', function () { place(); update(); });
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { place(); update(); }).observe(document.body);
    }
  }


  /* ---------------------------------------------------------
     BOOT
     --------------------------------------------------------- */
  function boot() {
    initSplit();
    initReveal();
    readParallax();
    onScroll();
    initHeader();
    initMenu();
    initDrawer();
    watchNewContent();
    initGate();
    initTrail();

    window.addEventListener('scroll', onScroll, { passive: true });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!reduced) {
          splitTargets.forEach(function (el) {
            var wasIn = el.classList.contains('is-in');
            splitLines(el);
            if (wasIn) el.classList.add('is-in');
          });
        }
        readParallax();
        onScroll();
        initTrail();
      }, 220);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* sezioni ricaricate dal theme editor */
  document.addEventListener('shopify:section:load', function () {
    initSplit();
    initReveal();
    readParallax();
    initMenu();
    initDrawer();
  });
})();
